import React, { useEffect, useState } from "react";
import { Activity, Download, Upload, Eye, ShieldOff, Loader2 } from "lucide-react";
import api from "@/lib/api";

const ACTION_META = {
  upload: { icon: Upload, label: "Uppladdat", color: "text-emerald-700 bg-emerald-50" },
  download: { icon: Download, label: "Nedladdat", color: "text-blue-700 bg-blue-50" },
  view: { icon: Eye, label: "Visat", color: "text-zinc-700 bg-zinc-50" },
  download_denied: { icon: ShieldOff, label: "Nekad åtkomst", color: "text-red-700 bg-red-50" },
};

function fmt(iso) {
  if (!iso) return "-";
  return new Date(iso).toLocaleString("sv-SE");
}

export default function CaseAccessLog({ caseId }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (!caseId) return;
    api.get(`/crm/cases/${caseId}/access-log`)
      .then((r) => setRows(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || "Kunde inte hämta logg"));
  }, [caseId]);

  return (
    <div className="bg-white border border-zinc-200 rounded-sm p-5" data-testid="case-access-log">
      <div className="flex items-center gap-2 mb-4">
        <Activity className="w-4 h-4 text-zinc-500" />
        <h3 className="text-base font-medium" style={{ fontFamily: "Outfit" }}>Dokument-åtkomstlogg</h3>
        <span className="ml-auto text-[10px] uppercase tracking-wider text-zinc-500">GDPR · spårbarhet</span>
      </div>
      {err && <div className="text-sm text-red-700">{err}</div>}
      {!rows && !err && (
        <div className="flex items-center gap-2 text-sm text-zinc-500"><Loader2 className="w-3 h-3 animate-spin" /> Hämtar...</div>
      )}
      {rows && rows.length === 0 && (
        <div className="text-sm text-zinc-500 text-center py-6">Inga dokumenthändelser ännu.</div>
      )}
      {rows && rows.length > 0 && (
        <ul className="space-y-2 max-h-72 overflow-y-auto">
          {rows.map((r, i) => {
            const m = ACTION_META[r.action] || ACTION_META.view;
            const Icon = m.icon;
            return (
              <li key={i} className="flex items-start gap-3 px-3 py-2 border border-zinc-100 rounded-sm hover:bg-zinc-50">
                <div className={`w-7 h-7 ${m.color} rounded-sm flex items-center justify-center flex-shrink-0`}>
                  <Icon className="w-3.5 h-3.5" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm text-zinc-900">
                    <b>{r.user_name || "Okänd"}</b> {m.label.toLowerCase()} <span className="text-zinc-600">{r.filename}</span>
                  </div>
                  <div className="text-[11px] text-zinc-500 mt-0.5">
                    {fmt(r.at)} · {r.user_role} {r.size_bytes ? `· ${Math.round(r.size_bytes/1024)} kB` : ""}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
